/* eslint-disable */
export default {
  saveLog: 'Guardar',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
